import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import '../../styles/sidebar.scss';

function Sidebar({ sidebarActive, toggleSidebar, filterData, applyFilters, clearFilters }) {
    const sidebarRef = useRef(null);
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    useEffect(() => {
        function handleClickOutside(event) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                toggleSidebar();
            }
        }

        if (sidebarActive) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [sidebarActive, toggleSidebar]);

    const toggleDropdown = (filterId) => {
        setOpenDropdowns(prev => ({
            ...prev,
            [filterId]: !prev[filterId]
        }));
    };

    const handleOptionSelect = (filter, option) => {
        const { selected, setSelected } = filter;
        const isSelected = selected.includes(option.name);
        
        if (isSelected) {
            setSelected(selected.filter(item => item !== option.name));
        } else {
            setSelected([...selected, option.name]);
        }
    };

    const getSelectedCount = (filter) => {
        return filter.selected.length;
    };

    const sidebarContent = (
        <div id="SideBar" ref={sidebarRef} className={`${sidebarActive ? 'active' : ''}`}>
            <div className="sidebarWrapper">
                <div className="filterWrapper">
                    {Object.entries(filterData).map(([key, filter]) => (
                        <div key={key}>
                            <h2>{filter.title}</h2>
                            <div className="custom-multi-select">
                                <div className="select-box" onClick={() => toggleDropdown(key)}>
                                    <div className="selected-items">
                                        {getSelectedCount(filter) > 0 
                                            ? `${getSelectedCount(filter)} valda`
                                            : 'Välj alternativ'}
                                    </div>
                                    <div className={`arrow ${openDropdowns[key] ? 'open' : ''}`}></div>
                                </div>
                                {openDropdowns[key] && (
                                    <div className="options-container">
                                        {filter.options.map((option) => (
                                            <div
                                                key={option.id}
                                                className={`option ${filter.selected.includes(option.name) ? 'selected' : ''}`}
                                                onClick={() => handleOptionSelect(filter, option)}
                                            >
                                                {option.name}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="ctaWrapper">
                    <button onClick={toggleSidebar} className="closeFilter">
                        Stäng Filter
                    </button>
                    <button onClick={clearFilters} className="clearFilter">
                        Rensa Filter
                    </button>
                </div>
            </div>
        </div>
    );

    return mounted ? ReactDOM.createPortal(sidebarContent, document.body) : null;
}

export default Sidebar;
